const updateStateWithKeyAndValue = (state, key, value) => {
  return { ...state, [key]: value };
};

const concatPayload = (existingValue, payload) => {
  return Array.isArray(existingValue)
    ? [...existingValue, ...(Array.isArray(payload) ? payload : [payload])]
    : [existingValue, ...(Array.isArray(payload) ? payload : [payload])];
};

const filterDeletedFeatures = (deletedFeature, feature) => {
  if (deletedFeature?.geometry?.type === "Point") {
    return (
      ((deletedFeature?.id === feature?.id) ||
        (deletedFeature?.geometry?.coordinates?.[0] ===
          feature?.geometry?.coordinates?.[0] &&
          deletedFeature?.geometry?.coordinates?.[1] ===
          feature?.geometry?.coordinates?.[1] &&
          deletedFeature?.geometry?.type === feature?.geometry?.type
        )
      )
    );
  }
  return (
    ((deletedFeature?.id === feature?.id) ||
      (deletedFeature?.geometry?.coordinates?.[0]?.[0]?.[1] ===
        feature?.geometry?.coordinates?.[0]?.[0]?.[1] &&
        deletedFeature?.geometry?.coordinates?.[0]?.[0]?.[1] ===
        feature?.geometry.coordinates?.[0]?.[0]?.[1] &&
        deletedFeature?.geometry?.type === feature?.geometry?.type
      )
    )
  );
};

const removeMapData = (state, stateKey, payload) => {
  if (stateKey === "locationData") {
    const updatedDrawnData = (state.locationData || []).filter((feature) => {
      return !payload?.some((deletedFeature) =>
        filterDeletedFeatures(deletedFeature, feature)
      );
    });
    return updateStateWithKeyAndValue(state, stateKey, updatedDrawnData);
  } else {
    return state;
  }
};

const setMapData = (state, stateKey, payload) => {
  return updateStateWithKeyAndValue(
    state,
    stateKey,
    stateKey in state ? concatPayload(state[stateKey], payload) : payload
  );
};

const handleDefaultCase = (state, action) => {
  const { payload, key: stateKey } = action;
  if (stateKey === "addSubmission") {
    return { ...state, locationData: null };
  } else if (
    payload &&
    typeof payload === "object" &&
    Object.keys(payload).length === 1 &&
    !stateKey
  ) {
    const [key, value] = Object.entries(payload)[0];
    return { ...state, [key]: value };
  } else if (payload !== undefined) {
    return {
      ...state,
      [stateKey]: payload,
    };
  }
  return state;
};

const INITIAL_STATE = {
  pendingMapInteractions: (() => {
    try {
      const raw = localStorage.getItem("pendingMapInteractions");
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  })(),
};

const reducer = (state = INITIAL_STATE, { payload, key: stateKey, type }) => {
  switch (type) {
    case "RECORD_MAP_INTERACTION": {
      const { ID, key } = payload || {};
      if (!ID || !key) return state;
      const existing = state.pendingMapInteractions || [];
      const idx = existing.findIndex((e) => e.ID === ID);
      if (idx === -1) {
        const newEntry = { ID, mapInteractions: { [key]: 1 } };
        const updated = [...existing, newEntry];
        try {
          localStorage.setItem("pendingMapInteractions", JSON.stringify(updated));
        } catch (e) { }
        return { ...state, pendingMapInteractions: updated };
      }
      const updatedEntry = { ...existing[idx] };
      updatedEntry.mapInteractions = { ...(updatedEntry.mapInteractions || {}) };
      updatedEntry.mapInteractions[key] = (updatedEntry.mapInteractions[key] || 0) + 1;
      const updatedList = [...existing];
      updatedList[idx] = updatedEntry;
      try {
        localStorage.setItem("pendingMapInteractions", JSON.stringify(updatedList));
      } catch (e) { }
      return { ...state, pendingMapInteractions: updatedList };
    }
    case "REMOVE_PENDING_MAP_INTERACTION": {
      const idToRemove = payload;
      const updated = (state.pendingMapInteractions || []).filter((e) => e.ID !== idToRemove);
      try { localStorage.setItem("pendingMapInteractions", JSON.stringify(updated)); } catch (e) { }
      return { ...state, pendingMapInteractions: updated };
    }
    case "CLEAR_PENDING_MAP_INTERACTIONS":
      try { localStorage.removeItem("pendingMapInteractions"); } catch (e) { }
      return { ...state, pendingMapInteractions: [] };
    case "GUEST_REQUEST_CODE_PENDING":
      return {
        ...state,
        guestAuth: { ...(state.guestAuth || {}), requesting: true, requestError: null, requestErrorMeta: null },
      };
    case "GUEST_REQUEST_CODE_SUCCESS":
      return {
        ...state,
        guestAuth: {
          ...(state.guestAuth || {}),
          requesting: false,
          requestError: null,
          requestErrorMeta: null,
          sessionID: payload?.sessionID || null,
        },
      };
    case "GUEST_REQUEST_CODE_ERROR":
      return {
        ...state,
        guestAuth: {
          ...(state.guestAuth || {}),
          requesting: false,
          requestError: payload?.messageKey || "guestCodeInvalid",
          requestErrorMeta: payload?.meta || null,
        },
      };
    case "GUEST_VERIFY_CODE_PENDING":
      return {
        ...state,
        guestAuth: { ...(state.guestAuth || {}), verifying: true, verifyError: null, verifyErrorMeta: null },
      };
    case "GUEST_VERIFY_CODE_SUCCESS":
      return {
        ...state,
        guestAuth: {
          ...(state.guestAuth || {}),
          verifying: false,
          verifyError: null,
          verifyErrorMeta: null,
          guestJwt: payload?.guestJwt || null,
        },
      };
    case "GUEST_VERIFY_CODE_ERROR":
      return {
        ...state,
        guestAuth: {
          ...(state.guestAuth || {}),
          verifying: false,
          verifyError: payload?.messageKey || "guestCodeInvalid",
          verifyErrorMeta: payload?.meta || null,
        },
      };
    case "GUEST_SESSION_CLEARED":
      return { ...state, guestAuth: {} };
    case "RESET_MAP_DATA":
      return { ...state, locationData: payload };
    case "REMOVE_MAP_DATA":
      return removeMapData(state, stateKey, payload);
    case "SET_MAP_DATA":
      return setMapData(state, stateKey, payload);
    default:
      return handleDefaultCase(state, { payload, key: stateKey, type });
  }
};

export default reducer;
